import React from "react";
import {
  Modal,
  Input,
  Row,
  Form,
  Col,
  Select,
  InputNumber,
  DatePicker
} from "antd";
import { compose, withState } from "recompose";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as R from "ramda";
import moment from "moment-timezone";
import { withForm } from "@worcket/common/hocs";

import { Currencies } from "../../../../../../utils/currencies";
import { getDefaultOfferLetterTemplate } from "../../../../selectors";
import JobOfferEditor from "../../../../../../components/inputs/JobOfferEditor";
import Button from "../../../../../../components/Button";

import locales from "./../../../../../../locales";

const Option = Select.Option;
const InputGroup = Input.Group;

const SendOffer = ({ onClose, onSubmit, loading, form, t }) => {
  const { getFieldDecorator } = form;
  return (
    <Modal
      visible
      centered
      width="950px"
      style={{ top: 40 }}
      maskClosable={false}
      title={t("opportunity:process.candidateDetails.offer.generate")}
      onCancel={() => !loading && onClose()}
      footer={[
        <Button key="quit" onClick={() => onClose()}>
          {t("global:cancel")}
        </Button>,
        <Button
          loading={loading}
          key="save"
          onClick={onSubmit}
          type="primary"
          htmlType="submit"
        >
          {t("opportunity:process.candidateDetails.offer.sendOffer")}
        </Button>
      ]}
    >
      <Form
        className="form"
        layout="vertical"
        onSubmit={onSubmit}
        data-test="send-offer-form"
      >
        <Row>
          <Form.Item label={t("opportunity:config.offerLetter.title")}>
            {getFieldDecorator("offerTemplate", {
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: t("form:emptyFieldValidation")
                }
              ]
            })(<JobOfferEditor t={t} />)}
          </Form.Item>
        </Row>
        <Row gutter={20} type="flex" justify="center" style={{ marginTop: 10 }}>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("opportunity:process.candidateDetails.offer.location")}
            >
              {getFieldDecorator("location", {
                rules: [
                  {
                    required: true,
                    message: t("form:emptyFieldValidation")
                  }
                ]
              })(<Input />)}
            </Form.Item>
            <Form.Item
              label={t("opportunity:process.candidateDetails.offer.salary")}
              validateStatus={form.getFieldError("salaryValue") && "error"}
              help={
                form.getFieldError("salaryValue") &&
                t("form:emptyFieldValidation")
              }
            >
              <InputGroup compact>
                {getFieldDecorator("salaryCurrency", {
                  rules: [
                    {
                      required: true,
                      message: t("form:emptyFieldValidation")
                    }
                  ]
                })(
                  <Select style={{ width: 170 }}>
                    {Currencies.map(item => (
                      <Option key={item.id} value={item.id}>
                        {item.description}
                      </Option>
                    ))}
                  </Select>
                )}
                {getFieldDecorator("salaryValue", {
                  rules: [
                    {
                      required: true,
                      message: t("form:emptyFieldValidation")
                    }
                  ]
                })(<InputNumber placeholder="25000" step={100} min={0} />)}
                <Input
                  style={{
                    width: 55,
                    zIndex: 1,
                    cursor: "default",
                    "text-align": "center"
                  }}
                  disabled
                  placeholder={form.getFieldValue("salaryCurrency")}
                />
                {getFieldDecorator("salaryType", {
                  rules: [
                    {
                      required: true,
                      message: t("form:emptyFieldValidation")
                    }
                  ]
                })(
                  <Select>
                    <Option value="Semanal">Semanal</Option>
                    <Option value="Quincenal">Quincenal</Option>
                    <Option value="Mensual">Mensual</Option>
                    <Option value="Anual">Anual</Option>
                  </Select>
                )}
              </InputGroup>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("opportunity:process.candidateDetails.offer.startDate")}
            >
              {getFieldDecorator("startDate", {
                rules: [
                  {
                    required: true,
                    message: t("form:emptyFieldValidation")
                  }
                ]
              })(
                <DatePicker
                  placeholder=""
                  style={{ width: "100%" }}
                  format={"DD/MM/YYYY"}
                />
              )}
            </Form.Item>
            <Form.Item
              label={t("opportunity:process.candidateDetails.offer.recruiter")}
            >
              {getFieldDecorator("recruiter", {
                rules: [
                  {
                    required: true,
                    message: t("form:emptyFieldValidation")
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default compose(
  withTranslation(["global", "opportunity", "form"]),
  connect(state => ({
    company: state.company,
    user: state.user,
    opportunity: state.opportunity.selected
  })),
  withState("loading", "setLoading", false),
  withForm({
    selector: (_, { company, opportunity, user }) => ({
      offerTemplate:
        R.path(["config", "offerLetterTemplate"], opportunity) ||
        getDefaultOfferLetterTemplate(company.logo),
      startDate: moment(),
      recruiter: user.name,
      salaryCurrency:
        opportunity?.currencyId ||
        R.path([company?.language, "currency", "id"], locales),
      salaryType: "Mensual",
      salaryValue: R.pathOr(0, ["salaryRange", "0"], opportunity)
    }),
    onSubmit: async (values, { match, onSubmit, onClose, setLoading }) => {
      setLoading(true);

      await onSubmit({
        idCandidate: match.id,
        idStep: match.step.id,
        formData: {
          ...values,
          startDate: new Date(values.startDate).getTime()
        }
      });

      setLoading(false);
      onClose();
    }
  })
)(SendOffer);
